"use strict";

const RecentPatientsCtrl = function(PatientsService) {
    var ctrl = this;

    ctrl.$onInit = function(){
      ctrl.request = PatientsService.findRecent().then(function(data){
        ctrl.recentPatients = data;
      });
    };
  };

RecentPatientsCtrl.$inject = ['PatientsService'];

module.exports = {
  template: require('./recent-patients.html'),
  controller: RecentPatientsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/list-recent-patients/recent-patients.component.js